<script setup lang="ts">
import SmallModel from "@/components/Interface/Modal/ModelSizes/SmallModel.vue";
import {useGameStore} from "@/stores/gameStore.ts";
import Backend from '@/models/backend.ts'
import { ref } from 'vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import RangeSlider from '@/components/Elements/Forms/RangeSlider.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Get the planet data
const gameStore = useGameStore()
const backend = new Backend()

const taxSlider = ref(10)

// Handle form submission
const submit = () => {
  backend.updatePlanetTax(
    gameStore.modalData,
    taxSlider.value
  ).then(() => {
    gameStore.modalType=''
  })
}

</script>

<template>
  <SmallModel :title="t('modals.setTax.title')">
    <div class="p-2">
      <div class="text-subtext pb-2">{{ t('modals.setTax.description') }}</div>
      <div class="xl:flex justify-between pl-2 pr-2">
        <div class="flex-1 p-2 flex">
          <img class="w-10 h-10 mr-3 rounded-3xl" :src="'' + gameStore.cdnUrl + 'images/population/64/taxman.webp'" alt="">
          <div class="relative mb-6 flex-grow">
            <RangeSlider
              v-model="taxSlider"
              :min="0"
              :max="100"
              :step="10"
            />
            <span class="text-subtext absolute start-0 -bottom-6">{{ t('modals.setTax.tax') }}: <span class="text-metal-300">{{ taxSlider }}%</span></span>
          </div>
        </div>
      </div>
      <div class="pt-2 text-center"><ActionButton @click="submit">{{ t('common.actions.submit') }}</ActionButton></div>
    </div>
  </SmallModel>
</template>


<style scoped lang="scss">
select {
  @apply bg-metal-600 p-1 text-metal-400 focus:outline-none
}
</style>